// @flow
import React from 'react';

import Highlights from 'components/rencontre/Highlights';
import type { RencontreType } from 'types/Rencontre';

import './CompetitionsInternationalesSingleMatchHighlights.css';
type Props = {
  rencontre: RencontreType
};

function CompetitionsInternationalesSingleMatchHighlights({ rencontre }: Props) {
  const {
    faits_de_jeu,
    meta: {
      adversaire_score,
      adversaire_score_mi_temps,
      afficher_faits_de_jeu,
      france_score,
      france_score_mi_temps,
      reception,
      rencontre_live
    }
  } = rencontre;

  return (
    <>
      <div className="single-match__highlights">
        {!afficher_faits_de_jeu ? (
          <p className="empty-state">
            Retrouvez ici le déroulé du match en direct.
            <br />
            Revenez vite pour ne rien manquer !
          </p>
        ) : (
          <>
            <h2 className="divided mb-7">
              <span className="first">Aperçu</span>
              <span className="second">du match</span>
            </h2>
            <Highlights
              faitsDeJeu={faits_de_jeu}
              francePlaysAtHome={reception}
              france_score_mi_temps={france_score_mi_temps}
              france_score={france_score}
              adversaire_score={adversaire_score}
              adversaire_score_mi_temps={adversaire_score_mi_temps}
              rencontre_live={rencontre_live}
            />
          </>
        )}
      </div>
    </>
  );
}

export default CompetitionsInternationalesSingleMatchHighlights;
